import React from 'react';

const Gallery = () => {
  return (
    <div className="container mx-auto max-w-screen-lg">
      <h1 className="text-4xl font-bold text-center my-6">Our Gallery</h1>
      <div className="grid grid-cols-1 md:grid-cols-10 gap-4">
        {/* Top Half (70% and 30%) */}
        <div className="col-span-10 md:col-span-7 bg-gray-100 rounded-xl overflow-hidden">
          <img
            src="/images/modernbedroomimg.jpg"
            alt="Gallery Item 1 best interior designers in hyderabad"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="col-span-10 md:col-span-3 bg-gray-100 rounded-xl overflow-hidden">
          <img
            src="/images/image2.jpg"
            alt="Gallery Item 2 best interior designers in hyderabad"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Bottom Half (30% and 70%) */}
        <div className="col-span-10 md:col-span-3 bg-gray-100 rounded-xl overflow-hidden">
          <img
            src="/images/image3.jpg"
            alt="Gallery Item 3 best interior designers in hyderabad"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="col-span-10 md:col-span-7 bg-gray-100 rounded-xl overflow-hidden">
          <img
            src="/images/UrbaneU.jpg"
            alt="Gallery Item 4 best interior designers in hyderabad"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default Gallery;
